{
  "first": {
    "docTitle": "Drop your first drawing",
    "title": "Drop your customer's drawing",
    "lede": "Pick one you ballooned by hand recently. Deburr balloons every dimension, tolerance, GD&T frame and note, and flags anything it isn't sure about. Then compare it with yours.",
    "ledeAt": "Pick one you ballooned by hand recently at {{shop}}. Deburr balloons every dimension, tolerance, GD&T frame and note, and flags anything it isn't sure about. Then compare it with yours.",
    "dropLabel": "Choose a drawing to upload",
    "dropTitle": "Drop a PDF or image here",
    "dropHint": "or click to choose a file. Multi-sheet PDFs are fine.",
    "steps": {
      "balloon": "Balloon",
      "check": "Check what it flagged",
      "readings": "Paste CMM output or type readings",
      "export": "Export the AS9102 PDF"
    },
    "sample": "No drawing handy? Try the sample part",
    "sampleBusy": "Setting up the sample part.",
    "skip": "Skip for now"
  },
  "checklist": {
    "title": "Your first report",
    "progress": "{{done}} of {{total}} done",
    "leftToCheck_one": "{{count}} left to check",
    "leftToCheck_other": "{{count}} left to check",
    "steps": {
      "uploaded": {
        "label": "Drop your customer's drawing",
        "hint": "Deburr balloons it"
      },
      "reviewed": {
        "label": "Check the flagged balloons",
        "hint": "Only the ones it was unsure of"
      },
      "readings": {
        "label": "Enter readings",
        "hint": "Paste CMM output or type them"
      },
      "exported": {
        "label": "Export the AS9102 report",
        "hint": "Forms 1, 2 and 3 as a PDF"
      },
      "invited": {
        "label": "Invite your approver",
        "hint": "Two-person sign-off"
      }
    }
  },
  "saved": {
    "label": "Hours saved",
    "underAnHour": "under an hour",
    "hours_one": "~{{count}} hour",
    "hours_other": "~{{count}} hours",
    "balloons_one": "{{count}} balloon",
    "balloons_other": "{{count}} balloons",
    "readings_one": "{{count}} reading imported",
    "readings_other": "{{count}} readings imported",
    "reports_one": "{{count}} report",
    "reports_other": "{{count}} reports",
    "estimate": "Estimate: {{perBalloon}} min per balloon, {{perReading}} min per imported reading, {{perReport}} min per report.",
    "thisMonth": "Deburr saved your shop {{hours}} this month.",
    "soFar": "Deburr saved your shop {{hours}} so far."
  }
}
